import dynamic from 'next/dynamic';
import Layout from '../../components/Layout';
import Seo from '../../components/Seo';

const ProductTemplate = dynamic(
  () => import('../../components/ProductTemplate')
);

const CompleteCurationPlatforms = ({ global }) => {
  return (
    <Layout global={global} withDownloadProduct={true}>
      <Seo seo={{}} />
      <ProductTemplate name="Complete Curation - Platforms" />
    </Layout>
  );
};

export default CompleteCurationPlatforms;
